export const ABOUT_CONTENT = {
  heading: ["Atmosphere first.", "Always."],
  body: [
    "I'm an independent artist creating music at the intersection of cinematic sound, bass house, and Kwaito-inspired rhythms with an occult edge. I build atmosphere first  —  tension, distance, and emotion  —  then layer it with heavy bass, minimal structures, and hypnotic patterns. My tracks move between control and collapse, silence and impact.",
    "I'm drawn to what's hidden, repetitive, and hard to explain — the kind of feeling that sits under the surface and doesn't let go. This is music for late hours, for reflection, for states you can't easily name.",
  ],
} as const;
